
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Palette } from "lucide-react";
import { ThemeToggle } from "@/components/theme/ThemeToggle";
import { useLanguage } from "@/hooks/useLanguage";

const AppearanceSection = () => {
  const { t } = useLanguage();

  return (
    <Card className="bg-gray-900/80 border-gray-600">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-ice-white">
          <Palette className="w-5 h-5 text-pink-500" />
          {t('appearance')}
        </CardTitle>
        <CardDescription className="text-gray-300">
          {t('appearance_description')}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ThemeToggle />
      </CardContent>
    </Card>
  );
};

export default AppearanceSection;
